import * as constants from './actions';

import { getInitiatedTime, getTimeFrom } from '../../utils/actionTiming';

const initialState = {
    actionCanceled: false,
    actionCompleted: false,
    actionInitiated: false,
    actionPreviouslyCancelled: false,
    isBackTransition: false,
    isPostalCodeSubmitting: false,
    isSubmitting: false,
    onPreloadScreen: true,
    postalCodeFormPopupIsVisible: false,
    selectedVolunteerOpportunity: undefined,
    volunteerOpportunities: undefined
};

export default function volunteer(state = initialState, { type, payload }) {
    switch (type) {
        case constants.VOLUNTEER_SIGNUP_FORM_SUBMITTING:
            return {
                ...state,
                isSubmitting: payload
            };
        case constants.VOLUNTEER_COMPLETED:
            return {
                ...state,
                successData: payload.data,
                actionIdentifier: payload.actionIdentifier,
                actionCompleted: true
            };
        case constants.IS_BACK_TRANSITION:
            return {
                ...state,
                isBackTransition: payload
            };
        case constants.SET_ON_PRELOAD_SCREEN:
            return {
                ...state,
                onPreloadScreen: payload
            };
        case constants.SET_LOCATION:
            return {
                ...state,
                postalCode: payload.postalCode,
                countryCode: payload.countryCode
            };
        case constants.SET_SELECTED_VOLUNTEER_OPPORTUNITY:
            return {
                ...state,
                selectedVolunteerOpportunity: payload
            };
        case constants.SET_VOLUNTEER_OPPORTUNITIES:
            return {
                ...state,
                volunteerOpportunities: payload
            };
        case constants.TOGGLE_LOCATION_FORM_SUBMITTING:
            return {
                ...state,
                isPostalCodeSubmitting: payload
            };
        case constants.VOLUNTEER_OPPORTUNITIES_LOADING:
            return {
                ...state,
                isVolunteerOpportunitiiesLoading: payload
            };
        case constants.VOLUNTEER_INITIATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state),
                actionInitiated: true
            };
        case constants.VOLUNTEER_CANCELED:
            return {
                ...state,
                actionPreviouslyCancelled: state.actionCancelled ? true : false,
                actionCanceled: true,
                actionCanceledTime: getTimeFrom(
                    Object.values(getInitiatedTime(payload, state))[0]
                )
            };
        case constants.TOGGLE_LOCATION_FORM_POPUP:
            return {
                ...state,
                postalCodeFormPopupIsVisible: payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Volunteer/reducer.js